// extracted by mini-css-extract-plugin
export default {"m":"_8f72c34976","title":"_034ecf1768","feedback_inner_title":"_7e704f6f2d","textarea":"c9cd585126","radio":"_2fed69e910","text":"_90f356d521"};